import React from 'react';
import { DropDownIcon } from './DropDownIcon';

export function MobilePlayerIcon() {
  return (
    <DropDownIcon
      childrenRender={() => (
        <>
          <rect width='50' height='50' rx='10' fill='#D9D9D9' />
          <rect x='14' y='5' width='23' height='40' rx='3' fill='#343434' />
          <rect x='20' y='7' width='11' height='1' rx='0.5' fill='#D9D9D9' />
          <circle cx='26' cy='40' r='2' fill='#D9D9D9' />
        </>
      )}
    />
  );
}
